import { render, staticRenderFns } from "./test-template-view.vue?vue&type=template&id=e59461aa&scoped=true&"
import script from "./test-template-view.vue?vue&type=script&lang=ts&"
export * from "./test-template-view.vue?vue&type=script&lang=ts&"
import style0 from "./test-template-view.vue?vue&type=style&index=0&id=e59461aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59461aa",
  null
  
)

export default component.exports